import React, { useContext } from 'react';
import { DesignerCard_UserFragment } from '@99designs/apps/spa/pages/create/components/DesignerCard.generated';
import { BriefContext } from '@99designs/brief';
import { DesignerMetaHeader } from '@99designs/designers';
import AddDesignerButton from './AddDesignerButton';

interface Props {
    brief: {
        id: string;
        designers: DesignerCard_UserFragment[];
        contacts: DesignerCard_UserFragment[];
    };
}

const Contacts = ({ brief }: Props) => {
    const { totalAllowableDesigners } = useContext(BriefContext);

    return (
        <div className="contacts-drawer__item-list">
            {brief.contacts.map((designer) => (
                <div className="contacts-drawer__item" key={designer.id}>
                    <div className="contacts-drawer__meta-wrapper">
                        <DesignerMetaHeader
                            designer={designer}
                            paragraphSize={'small'}
                            avatarSize={'small'}
                        />
                        <div className="contacts-drawer__meta-wrapper__cta">
                            <AddDesignerButton
                                designer={designer}
                                designerSource={'CONTACT'}
                                brief={brief}
                                totalAllowableDesigners={totalAllowableDesigners}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Contacts;
